var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('side-bar',{attrs:{"logo":_vm.logo}},[_c('template',{slot:"links"},[(_vm.type == 1)?_c('sidebar-item',{attrs:{"link":{
          name: 'Company Managment',
          icon: 'fas fa-users-cog text-pink',
          path: '/company-management/list'
        }}}):_vm._e(),(_vm.type == 1 || _vm.type == 2)?_c('sidebar-item',{attrs:{"link":{
          name: 'Site Management',
          icon: 'fas fa-sitemap text-default',
          path: '/site-management/list'
        }}}):_vm._e(),(_vm.type == 1)?_c('sidebar-item',{attrs:{"link":{
          name: 'Device Management',
          icon: 'fas fa-laptop text-primary',
          path: '/device-management/list'
        }}}):_vm._e(),(_vm.type == 1 || _vm.type == 2)?_c('sidebar-item',{attrs:{"link":{
          name: 'User Management',
          icon: 'fas fa-user-tie text-green',
          path: '/user-management/list'
        }}}):_vm._e(),(_vm.type == 2)?_c('sidebar-item',{attrs:{"link":{
          name: 'Question',
          icon: 'fas fa-question-circle text-orange',
          path: '/question/list'
        }}}):_vm._e(),(_vm.type == 2)?_c('sidebar-item',{attrs:{"link":{
          name: 'Questionnaires',
          icon: 'fas fa-file-invoice text-info',
          path: '/questionnaires/list'
        }}}):_vm._e(),(_vm.type == 2 || _vm.type == 4)?_c('sidebar-item',{attrs:{"link":{
          name: 'Questionnaire Questions',
          // icon: 'fas fa-ban text-green',
          icon: 'fas fa-file-signature text-green',
          path: '/questionnaire-questions/list'
        }}}):_vm._e(),(_vm.type == 2 || _vm.type == 4)?_c('sidebar-item',{attrs:{"link":{
          name: 'Assign Questionnaires to the site',
          icon: 'fas fa-share-square text-default',
          path: '/assign-questionnaires-to-the-site/list'
        }}}):_vm._e(),(_vm.type == 2 || _vm.type == 4 || _vm.type == 6)?_c('sidebar-item',{attrs:{"link":{
          name: 'Visitor Request Approval',
          icon: 'fas fa-clipboard-check text-info',
          path: '/visitor-request-approval/list'
        }}}):_vm._e(),(_vm.type == '')?_c('sidebar-item',{attrs:{"link":{
          name: 'Visitor',
          icon: 'fas fa-id-card-alt text-green',
          path: '/visitor'
        }}}):_vm._e(),(_vm.type == 4 || _vm.type == 5)?_c('sidebar-item',{attrs:{"link":{
          name: 'Visitor Management',
          icon: 'fas fa-address-card text-red',
          path: '/visitor-management'
        }}}):_vm._e(),(_vm.type == 3)?_c('sidebar-item',{attrs:{"link":{
          name: 'Edit Profile',
          icon: 'fas fa-user-cog text-red',
          path: '/visitor-edit-profile'
        }}}):_vm._e(),(_vm.type == 3)?_c('sidebar-item',{attrs:{"link":{
          name: 'Group Management',
          icon: 'fas fa-users-cog text-blue',
          path: '/group-management/list'
        }}}):_vm._e(),(_vm.type == 1 || _vm.type == 2 || _vm.type == 4 || _vm.type == 6)?_c('sidebar-item',{attrs:{"link":{
          name: 'Report',
          icon: 'fas fa-file-alt text-orange',
          path: '/report'
        }}}):_vm._e(),(_vm.type == 1)?_c('sidebar-item',{attrs:{"link":{
          name: 'Document Type',
          icon: 'fas fa-file-alt text-blue',
          path: '/document-management/list'
        }}}):_vm._e()],1)],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{staticClass:"content-area",on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }